import { getLanguages } from "@/api/languages/languages-services";

export const languageListSlice = (set, get) => ({
  languageList: [],

  //PARA MANEJAR EL IDIOMA DE TODA LA APLICACIÓN
  selectedLanguage: (navigator.language || "es").split("-")[0],

  getLanguageList: async () => {
    const response = await getLanguages();
    let normalizedLanguageList = [];

    if (Array.isArray(response)) {
      normalizedLanguageList = response;
    } else if (Array.isArray(response?.languages)) {
      normalizedLanguageList = response.languages;
    } else if (typeof response === "string") {
      try {
        const parsed = JSON.parse(response);
        if (Array.isArray(parsed)) {
          normalizedLanguageList = parsed;
        }
      } catch (_e) {
        normalizedLanguageList = [];
      }
    }

    set({ languageList: normalizedLanguageList });
  },

  setSelectedLanguage: (value) => {
    set({ selectedLanguage: value });
  },
});
